// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StripeSuccessRouteImport } from './routes/stripe.success'
import { Route as CallbackDiscordRouteImport } from './routes/callback.discord'
import { Route as AuthedDashboardIndexRouteImport } from './routes/_authed/dashboard/index'
import { Route as AuthedDashboardManageSubscriptionRouteImport } from './routes/_authed/dashboard/manage-subscription'
import { Route as AuthedDashboardSubscriptionsIndexRouteImport } from './routes/_authed/dashboard/subscriptions/index'
import { Route as AuthedDashboardGuildIdIndexRouteImport } from './routes/_authed/dashboard/$guildId/index'
import { Route as AuthedDashboardGuildIdSubscribeRouteImport } from './routes/_authed/dashboard/$guildId/subscribe'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SsoCallbackRoute = SsoCallbackRouteImport.update({
            id: '/sso-callback',path: '/sso-callback',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StripeSuccessRoute = StripeSuccessRouteImport.update({
            id: '/stripe/success',path: '/stripe/success',getParentRoute: () => rootRouteImport
          })
const CallbackDiscordRoute = CallbackDiscordRouteImport.update({
            id: '/callback/discord',path: '/callback/discord',getParentRoute: () => rootRouteImport
          })
const AuthedDashboardIndexRoute = AuthedDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardManageSubscriptionRoute = AuthedDashboardManageSubscriptionRouteImport.update({
            id: '/dashboard/manage-subscription',path: '/dashboard/manage-subscription',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardSubscriptionsIndexRoute = AuthedDashboardSubscriptionsIndexRouteImport.update({
            id: '/dashboard/subscriptions/',path: '/dashboard/subscriptions/',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardGuildIdIndexRoute = AuthedDashboardGuildIdIndexRouteImport.update({
            id: '/dashboard/$guildId/',path: '/dashboard/$guildId/',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardGuildIdSubscribeRoute = AuthedDashboardGuildIdSubscribeRouteImport.update({
            id: '/dashboard/$guildId/subscribe',path: '/dashboard/$guildId/subscribe',getParentRoute: () => AuthedRoute
          })





const AuthedRouteChildren = {
  AuthedDashboardManageSubscriptionRoute: AuthedDashboardManageSubscriptionRoute,AuthedDashboardIndexRoute: AuthedDashboardIndexRoute,AuthedDashboardGuildIdSubscribeRoute: AuthedDashboardGuildIdSubscribeRoute,AuthedDashboardGuildIdIndexRoute: AuthedDashboardGuildIdIndexRoute,AuthedDashboardSubscriptionsIndexRoute: AuthedDashboardSubscriptionsIndexRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,PrivacyRoute: PrivacyRoute,SignInRoute: SignInRoute,SsoCallbackRoute: SsoCallbackRoute,TermsRoute: TermsRoute,CallbackDiscordRoute: CallbackDiscordRoute,StripeSuccessRoute: StripeSuccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)